import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {catchError, finalize, Subject, takeUntil} from "rxjs";
import {fuseAnimations} from "@fuse/animations";
import {MatDialogModule} from "@angular/material/dialog";
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRippleModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTab, MatTabChangeEvent, MatTabContent, MatTabGroup} from '@angular/material/tabs';
import {environment} from '../../../../../environments/environment';
import {FuseConfirmationService} from '../../../../../@fuse/services/confirmation';
import {GalleryModule} from 'ng-gallery';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RestFactoryService} from '../../../../core/services/rest-factory.service';
import '../../../../core/quill-options/gold-text';
import {GoogleMapsModule} from '@angular/google-maps';
import {NgxSpinnerComponent, NgxSpinnerService} from "ngx-spinner";
import {SpecialOffersType} from "../../../content/destinations/destinations.types";
import {LayoutType} from "../types/layouts-types";
import {deepEqual, findOtherKeyValue, moveItemByOrder} from "../../../../core/services/utils";
import {SectionType, SectionTypeOptions} from "../../../../../environments/fixed-enum";
import {CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList} from "@angular/cdk/drag-drop";

@Component({
    selector: "layouts-management",
    styleUrls: ["./layouts-management.component.scss"],
    templateUrl: "./layouts-management.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatToolbarModule,
        MatDialogModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        MatTabGroup,
        MatTab,
        MatTabContent,
        FormsModule,
        GalleryModule,
        GoogleMapsModule,  // Import GoogleMapsModule
        NgxSpinnerComponent,
        CdkDropList,
        CdkDrag,
    ]
})
export class LayoutsManagementComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() commandEvent = new EventEmitter<string>(); // Declare the output property
    @Input() destination_ID: any; // Declare the input property

    // A method that emits the command event
    sendCommand(command: string) {
        this.commandEvent.emit(command);
    }

    // Bind this variable to the selectedIndex of mat-tab-group
    selectedIndex = 0;
    // Keep track of the previous tab index
    previousIndex = 0;

    orderSelected: number = null;

    disableAutoSave: boolean = true;
    loadingMessage: string = null;

    layout: any;
    componentList: any[] = [];

    componentTypeList: any[] = SectionTypeOptions;

    selectedComponent: any = null;
    orderList: number[] = Array.from({ length: 10 }, (_, i) => i + 1);

    flashMessage: 'success' | 'error' | null = null;

    exampleData: LayoutType = {
        "bl_addgparenttocities": true,
        "bl_addnavigationprops": true,
        "bl_hidedestinations": true,
        "ds_actiondata1": "",
        "ds_actiondata2": "",
        "ds_actiondata3": "",
        "ds_actionsubtitle1": "",
        "ds_actionsubtitle2": "",
        "ds_actionsubtitle3": "",
        "ds_actiontitle1": "",
        "ds_actiontitle2": "",
        "ds_actiontitle3": "",
        "ds_actionurl1": "",
        "ds_actionurl2": "",
        "ds_actionurl3": "",
        "ds_buttonadata1": "",
        "ds_buttonadata10": "",
        "ds_buttonadata2": "",
        "ds_buttonadata3": "",
        "ds_buttonadata4": "",
        "ds_buttonadata5": "",
        "ds_buttonadata6": "",
        "ds_buttonadata7": "",
        "ds_buttonadata8": "",
        "ds_buttonadata9": "",
        "ds_buttonalabel1": "",
        "ds_buttonalabel10": "",
        "ds_buttonalabel2": "",
        "ds_buttonalabel3": "",
        "ds_buttonalabel4": "",
        "ds_buttonalabel5": "",
        "ds_buttonalabel6": "",
        "ds_buttonalabel7": "",
        "ds_buttonalabel8": "",
        "ds_buttonalabel9": "",
        "ds_buttonaurl1": "",
        "ds_buttonaurl10": "",
        "ds_buttonaurl2": "",
        "ds_buttonaurl3": "",
        "ds_buttonaurl4": "",
        "ds_buttonaurl5": "",
        "ds_buttonaurl6": "",
        "ds_buttonaurl7": "",
        "ds_buttonaurl8": "",
        "ds_buttonaurl9": "",
        "ds_buttonbdata1": "",
        "ds_buttonbdata10": "",
        "ds_buttonbdata2": "",
        "ds_buttonbdata3": "",
        "ds_buttonbdata4": "",
        "ds_buttonbdata5": "",
        "ds_buttonbdata6": "",
        "ds_buttonbdata7": "",
        "ds_buttonbdata8": "",
        "ds_buttonbdata9": "",
        "ds_buttonblabel1": "",
        "ds_buttonblabel10": "",
        "ds_buttonblabel2": "",
        "ds_buttonblabel3": "",
        "ds_buttonblabel4": "",
        "ds_buttonblabel5": "",
        "ds_buttonblabel6": "",
        "ds_buttonblabel7": "",
        "ds_buttonblabel8": "",
        "ds_buttonblabel9": "",
        "ds_buttonburl1": "",
        "ds_buttonburl10": "",
        "ds_buttonburl2": "",
        "ds_buttonburl3": "",
        "ds_buttonburl4": "",
        "ds_buttonburl5": "",
        "ds_buttonburl6": "",
        "ds_buttonburl7": "",
        "ds_buttonburl8": "",
        "ds_buttonburl9": "",
        "ds_data": "",
        "ds_data1": "",
        "ds_data10": "",
        "ds_data2": "",
        "ds_data3": "",
        "ds_data4": "",
        "ds_data5": "",
        "ds_data6": "",
        "ds_data7": "",
        "ds_data8": "",
        "ds_data9": "",
        "ds_en_actiontype1": "Undefined",
        "ds_en_actiontype2": "Undefined",
        "ds_en_actiontype3": "Undefined",
        "ds_en_buttonatype1": "Undefined",
        "ds_en_buttonatype10": "Undefined",
        "ds_en_buttonatype2": "Undefined",
        "ds_en_buttonatype3": "Undefined",
        "ds_en_buttonatype4": "Undefined",
        "ds_en_buttonatype5": "Undefined",
        "ds_en_buttonatype6": "Undefined",
        "ds_en_buttonatype7": "Undefined",
        "ds_en_buttonatype8": "Undefined",
        "ds_en_buttonatype9": "Undefined",
        "ds_en_buttonbtype1": "Undefined",
        "ds_en_buttonbtype10": "Undefined",
        "ds_en_buttonbtype2": "Undefined",
        "ds_en_buttonbtype3": "Undefined",
        "ds_en_buttonbtype4": "Undefined",
        "ds_en_buttonbtype5": "Undefined",
        "ds_en_buttonbtype6": "Undefined",
        "ds_en_buttonbtype7": "Undefined",
        "ds_en_buttonbtype8": "Undefined",
        "ds_en_buttonbtype9": "Undefined",
        "ds_en_sectiontype": "Undefined Sec Type",
        "ds_en_sectiontype1": "Undefined Sec Type",
        "ds_en_sectiontype10": "Undefined Sec Type",
        "ds_en_sectiontype2": "Undefined Sec Type",
        "ds_en_sectiontype3": "Undefined Sec Type",
        "ds_en_sectiontype4": "Undefined Sec Type",
        "ds_en_sectiontype5": "Undefined Sec Type",
        "ds_en_sectiontype6": "Undefined Sec Type",
        "ds_en_sectiontype7": "Undefined Sec Type",
        "ds_en_sectiontype8": "Undefined Sec Type",
        "ds_en_sectiontype9": "Undefined Sec Type",
        "ds_layout1": "City",
        "ds_layout2": "City",
        "ds_layout3": "City",
        "ds_layout4": "City",
        "ds_layout5": "City",
        "ds_overridedestinationtarget": "",
        "ds_subtitle": "",
        "ds_subtitle1": "",
        "ds_subtitle10": "",
        "ds_subtitle2": "",
        "ds_subtitle3": "",
        "ds_subtitle4": "",
        "ds_subtitle5": "",
        "ds_subtitle6": "",
        "ds_subtitle7": "",
        "ds_subtitle8": "",
        "ds_subtitle9": "",
        "ds_title": "",
        "ds_title1": "",
        "ds_title10": "",
        "ds_title2": "",
        "ds_title3": "",
        "ds_title4": "",
        "ds_title5": "",
        "ds_title6": "",
        "ds_title7": "",
        "ds_title8": "",
        "ds_title9": "",
        "ds_url": "",
        "ds_url1": "",
        "ds_url10": "",
        "ds_url2": "",
        "ds_url3": "",
        "ds_url4": "",
        "ds_url5": "",
        "ds_url6": "",
        "ds_url7": "",
        "ds_url8": "",
        "ds_url9": "",
        "en_actiontype1": 0,
        "en_actiontype2": 0,
        "en_actiontype3": 0,
        "en_buttonatype1": 0,
        "en_buttonatype10": 0,
        "en_buttonatype2": 0,
        "en_buttonatype3": 0,
        "en_buttonatype4": 0,
        "en_buttonatype5": 0,
        "en_buttonatype6": 0,
        "en_buttonatype7": 0,
        "en_buttonatype8": 0,
        "en_buttonatype9": 0,
        "en_buttonbtype1": 0,
        "en_buttonbtype10": 0,
        "en_buttonbtype2": 0,
        "en_buttonbtype3": 0,
        "en_buttonbtype4": 0,
        "en_buttonbtype5": 0,
        "en_buttonbtype6": 0,
        "en_buttonbtype7": 0,
        "en_buttonbtype8": 0,
        "en_buttonbtype9": 0,
        "en_maindestinationtype": 0,
        "en_sectiontype": 0,
        "en_sectiontype1": 0,
        "en_sectiontype10": 0,
        "en_sectiontype2": 0,
        "en_sectiontype3": 0,
        "en_sectiontype4": 0,
        "en_sectiontype5": 0,
        "en_sectiontype6": 0,
        "en_sectiontype7": 0,
        "en_sectiontype8": 0,
        "en_sectiontype9": 0,
        "id_destinationtype": "",
        "id_destinationtypelayout": "",
        "id_displaylayout": "",
    }

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    private API_OWNER_GET_DESTINATION = "/admin/skin/destinationtypelayout/get";
    private API_POST_DESTINATION = "/admin/skin/destinationtypelayout/set";
    private API_DELETE_DESTINATION = "/admin/destination/delete";

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _formBuilder: UntypedFormBuilder,
        private _fuseConfirmationService: FuseConfirmationService,
        private _restFactoryService: RestFactoryService,
        private spinner: NgxSpinnerService,
        private _snackBar: MatSnackBar
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.componentList = this.transformLayoutToObjects(this.exampleData);
        this.layout = this.componentList.shift();
        this.dataInitializer();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    ngAfterViewInit(): void {
        // if (!this.map && this.mapElement && this.mapElement.nativeElement) {
        // }
        setTimeout(() => {
            this.disableAutoSave = false;
        }, 3000);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public Methods
    // -----------------------------------------------------------------------------------------------------

    transformLayoutToObjects(layout: { [key: string]: any }): any[] {
        const groupedObjects: any[] = [];
        const specialObject: { [key: string]: any } = {};

        const suffixes = Array.from(
            new Set(
                Object.keys(layout)
                    .map((key) => key.match(/\d+$/)?.[0])
                    .filter((suffix): suffix is string => !!suffix)
            )
        );

        suffixes.forEach((suffix) => {
            const obj: { [key: string]: any } = {};

            Object.keys(layout).forEach((key) => {
                if (key.endsWith(suffix)) {
                    const trimmedKey = key.replace(/\d+$/, '');
                    obj[trimmedKey] = layout[key];
                }
            });

            if (!obj.hasOwnProperty('im_image')) {
                obj.im_image = null;
            }

            obj.order = parseInt(suffix, 10);
            groupedObjects.push(obj);
        });

        Object.keys(layout).forEach((key) => {
            if (!key.match(/\d+$/)) {
                specialObject[key] = layout[key];
            }
        });

        return [specialObject, ...groupedObjects];
    }

    reverseTransformLayoutObjects(objects: any[]): { [key: string]: any } {
        const result: { [key: string]: any } = {};

        objects.forEach((group) => {
            if (group.hasOwnProperty('order') && group.order !== undefined && group.order !== null) {
                // Ensure the order is treated as a string
                const suffix = String(group.order);
                Object.keys(group).forEach((key) => {
                    if (key === "order") return;
                    result[`${key}${suffix}`] = group[key];
                });
            } else {
                // Merge keys as is, without adding any suffix
                Object.keys(group).forEach((key) => {
                    result[key] = group[key];
                });
            }
        });

        return result;
    }

    extractInconsistentKeys(
        arr: any[],
        orderKey: string = 'order'
    ): { surplus: { [key: string]: any }, standardized: any[] } {
        if (!arr || arr.length === 0) {
            return { surplus: {}, standardized: [] };
        }

        // Step 1: Compute the common keys (intersection) across all objects.
        // Start with the keys from the first object.
        const commonKeys = Object.keys(arr[0]);
        // Intersect with keys of each subsequent object.
        for (let i = 1; i < arr.length; i++) {
            const keys = Object.keys(arr[i]);
            for (let j = commonKeys.length - 1; j >= 0; j--) {
                if (!keys.includes(commonKeys[j])) {
                    commonKeys.splice(j, 1);
                }
            }
        }

        // Step 2: For each object, remove keys that are not common and add them to the surplus object.
        const surplus: { [key: string]: any } = {};
        const standardized = arr.map((obj) => {
            // Make a copy so we do not modify the original object
            const newObj = { ...obj };
            const orderVal = obj[orderKey];
            Object.keys(obj).forEach((key) => {
                if (!commonKeys.includes(key)) {
                    // Add key to surplus with suffix equal to the order value.
                    surplus[`${key}${orderVal}`] = obj[key];
                    // Remove the key from the object so that all objects remain uniform.
                    delete newObj[key];
                }
            });
            return newObj;
        });

        // Optional: Log the surplus object
        console.log("Surplus object:", surplus);
        console.log("Standardized object:", standardized);

        return { surplus, standardized };
    }


    /**
     * Initialize missing data in the object...
     */
    dataInitializer() {
        const payload = new FormData();
        let dynaAPI = this.API_OWNER_GET_DESTINATION;
        payload.append("id_destinationtypelayout", this.destination_ID);
        this._unsubscribeAll.next(null);
        this._restFactoryService.httpPostService(dynaAPI, payload)
            .pipe(
                takeUntil(this._unsubscribeAll),
                finalize(() => {
                    this._changeDetectorRef.detectChanges();
                }),
                catchError((err) => {
                    return err;
                })
            )
            .subscribe(
                (response) => {
                    this.componentList = this.transformLayoutToObjects(response.layout);
                    this.layout = this.componentList.shift();
                    const tempObject = this.extractInconsistentKeys(this.componentList);
                    this.layout = Object.assign({}, this.layout, tempObject.surplus)
                    this.componentList = tempObject.standardized;
                    this._changeDetectorRef.detectChanges();
                });
    }

    /**
     * Save and close
     */
    saveAndClose(navigate = false): void {
        let original = this.reverseTransformLayoutObjects(this.componentList);
        original = {...original, ...this.layout};
        console.log(original);
        const payload = new FormData();
        payload.append("js_destinationtypelayout", JSON.stringify(original));
        this._unsubscribeAll.next(null);
        this._restFactoryService.httpPostService(this.API_POST_DESTINATION, payload)
            .pipe(
                takeUntil(this._unsubscribeAll),
                finalize(() => {
                    this._changeDetectorRef.detectChanges();
                }),
                catchError((err) => {
                    return err;
                })
            )
            .subscribe(
                () => {
                    this.selectedComponent = null;
                    this.orderSelected = 1;
                    this._changeDetectorRef.detectChanges();
                });
    }

    onInputMaxReach(event: any, maxReach: number = 15): void {
        const inputValue = event.target.value;
        if (inputValue.length >= maxReach) {
            // The input value has reached or exceeded the limit
            // You can take appropriate action here
            this._snackBar.open(`This field has a limit of ${maxReach} characters. Any text exceeding this limit will be cut off.`, "Close", {
                duration: 5000,  // Duration is in milliseconds (5000ms = 5s),
                panelClass: ['bg-card', 'dark:bg-transparent']
            });
        }
    }




    // -----------------------------------------------------------------------------------------------------
    // @ Component List Stuff
    // -----------------------------------------------------------------------------------------------------

    drop(event: CdkDragDrop<any[]>): void {
        // Reorder the array based on the drag event
        console.log('list', this.componentList);
        console.log('previousIndex', event.previousIndex);
        console.log('currentIndex', event.currentIndex);
        this.componentList = moveItemByOrder(this.componentList, event.previousIndex + 1, event.currentIndex + 1);
        console.log('list', this.componentList);
        this._changeDetectorRef.detectChanges();
        this.saveAndClose();
    }

    saveSpecialOffer(): void {
        // this.componentList[this.orderSelected-1] = this.selectedComponent;?
        let reorderedList = moveItemByOrder(this.componentList, this.selectedComponent.order, this.orderSelected);
        this.selectedComponent.order = this.orderSelected;
        const targetIndex = reorderedList.findIndex(item => item.order === this.orderSelected);
        if (targetIndex !== -1) {
            reorderedList[targetIndex] = this.selectedComponent;
        }
        this.componentList = [...reorderedList];
        this.saveAndClose();
    }

    /**
     * Toggle product details
     *
     * @param soID
     */
    toggleDetails(soID: any): void {
        // If the product is already selected...
        if (this.selectedComponent && this.selectedComponent.order === soID) {
            // Close the details
            this.closeDetails();
            return;
        }

        // Find the selected special offer
        this.selectedComponent = structuredClone(this.componentList.find(item => item.order === soID));
        this.orderSelected = soID;

        this._changeDetectorRef.markForCheck();
    }

    /**
     * Close the details
     */
    closeDetails(): boolean {
        if (this.selectedComponent && !deepEqual(this.selectedComponent, this.componentList[this.orderSelected-1]) ) {
            const message = this._fuseConfirmationService.open({
                title: "Warning!",
                message: "The component is not saved, and will be lost on toggle!",
                actions: {
                    confirm: {
                        show: true
                    },
                    cancel: {
                        show: true
                    }
                },
                dismissible: false
            });
            message.afterClosed().subscribe(
                (value) => {
                    if (value === "confirmed") {
                        this.selectedComponent = null;
                        this._changeDetectorRef.markForCheck();
                        return true;
                    } else {
                        return false;
                    }
                }
            );
        } else {
            this.selectedComponent = null;
            this._changeDetectorRef.markForCheck();
            return true;
        }
    }


    onTabChange(event: MatTabChangeEvent): void {
        // Insert your condition here. For example, you might check for unsaved changes.

        if (!this.closeDetails()) {
            // Revert back to the previous tab if the condition fails.
            this.selectedIndex = this.previousIndex;
        } else {
            // If the condition is met, update the previous index.
            this.previousIndex = event.index;
        }
    }

    changeComponentTypeName(event: any): void {
        this.selectedComponent.ds_en_sectiontype = findOtherKeyValue(this.componentTypeList, event.value, 'name');
    }

}
